import { Box, Stack } from "@mui/material";

type Props = {
  expandLeft?: boolean;
  left: React.ReactNode;
  right: React.ReactNode;
};

const LeftRight = ({ expandLeft = false, left, right }: Props) => {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={2}
      display="flex"
      alignItems={{ xs: "stretch", sm: "center" }}
      sx={{ width: "100%", minWidth: 0 }}
    >
      {expandLeft ? (
        <Box flexGrow={1} minWidth={0} width="100%">
          {left}
        </Box>
      ) : (
        <Box minWidth={0} sx={{ width: { xs: "100%", sm: "auto" } }}>
          {left}
        </Box>
      )}
      {right ? (
        <Box
          sx={{
            flexShrink: 0,
            alignSelf: { xs: "flex-end", sm: "center" },
          }}
        >
          {right}
        </Box>
      ) : null}
    </Stack>
  );
};

export default LeftRight;
